import { ReferralLinkFormValidationSchema } from '@/modules/Sites';

export const referralLinksFormValidationSchema: ReferralLinkFormValidationSchema = {
  links: []
};
